(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    // "See the size on the wall" opens the size guide inside the Bozetto product tabs block.
  // When the link has a custom URL (no matching #pt-<id> target) it behaves as a normal link.
  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-size-guide-link]') : null;
    if (!link) return;

    const hash = link.hash || '';
    if (!hash.startsWith('#pt-')) return;

    // Only intercept when the size guide is on this page; from the quick-add modal the link navigates.
    const tabs = document.getElementById(hash.slice(1));
    const trigger = tabs?.querySelector('.bzg-item[data-target="size"]');
    if (!trigger) return;

    event.preventDefault();
    if (trigger.getAttribute('aria-expanded') !== 'true') trigger.click();
    tabs.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
